import { BOOKS, getBook } from "../data/books";
import { MODELS } from "../data/models";
import { BookCover } from "../components/BookCover";
import { GiftScene, GiftBunting } from "../components/GiftScene";
import { useApp } from "../context/AppContext";

export function HomePage() {
  const { go } = useApp();
  const diwaliBook = getBook("diwali");
  return (
    <main>
      <section className="hero">
        <div className="wrap hero-grid">
          <div>
            <h1 style={{ marginTop: 0 }}>
              The bedtime story that stars your little one
            </h1>
            <p className="lead">
              Personalized picture books that celebrate food, family, traditions and tiny humans we love. Just pick a
              story and a character that looks just like them, and we'll send you a book to bring magic to your
              next story time.
            </p>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <button
                className="btn btn-rust big"
                onClick={() => {
                  document.getElementById("books")?.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                Browse the collection <span className="arr">→</span>
              </button>
              <button className="btn btn-ghost big" onClick={() => go({ name: "personalize", bookId: "lunar" })}>
                See how it works
              </button>
            </div>
            <div className="hero-meta">
              <div>
                <b>4</b>
                <span>customizable stories</span>
              </div>
              <div>
                <b>12</b>
                <span>character models</span>
              </div>
              <div>
                <b>32pp</b>
                <span>softcover or hardcover</span>
              </div>
            </div>
          </div>
          <div className="hero-stack">
            <div className="hero-book b1">
              <BookCover book={BOOKS[3]!} name={BOOKS[3]!.placeholderName} model={MODELS[5]} />
            </div>
            <div className="hero-book b2">
              <BookCover book={BOOKS[1]!} name={BOOKS[1]!.placeholderName} model={MODELS[4]} />
            </div>
            <div className="hero-book b3">
              <BookCover book={BOOKS[2]!} name={BOOKS[2]!.placeholderName} model={MODELS[8]} />
            </div>
            <div className="hero-book b4">
              <BookCover book={BOOKS[0]!} name={BOOKS[0]!.placeholderName} model={MODELS[6]} />
            </div>
          </div>
        </div>
      </section>

      {diwaliBook && (
        <section className="gift-cta">
          <div className="wrap gift-grid">
            <div className="gift-copy">
              <span className="eyebrow">A Hushberry Book</span>
              <h2>
                The perfect <span className="it">gift.</span>
              </h2>
              <p>
                Our personalized books make the perfect gift for children's birthday parties. Our books start at only $34. 
                Seeing their face light up when they notice that it's a book about them and their family? Absolutely priceless.
              </p>
              <ul className="gift-bullets">
                <li>Personalised cover with their name</li>
                <li>Hand-written dedication, printed inside</li>
                <li>Beautifully wrapped, ready to gift</li>
              </ul>
              <button
                className="btn btn-rust big"
                onClick={() => {
                  document.getElementById("books")?.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                Gift a book <span className="arr">→</span>
              </button>
            </div>
            <div className="gift-polaroid">
              <div className="gift-scene">
                <GiftScene />
                <GiftBunting />
                <div className="gift-book">
                  <BookCover book={diwaliBook} name={diwaliBook.placeholderName} model={MODELS[8]} />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <section className="section first" id="books">
        <div className="wrap">
          <div className="section-head">
            <div>
              <span className="eyebrow">— Our Library</span>
              <h2>
                Four <span className="it">stories</span> to make your own.
              </h2>
            </div>
          </div>
          <div className="book-grid">
            {BOOKS.map((b) => {
              const modelIdx = b.id === "lunar" ? 6 : b.id === "hanukkah" ? 4 : b.id === "diwali" ? 8 : 5;
              return (
                <button key={b.id} className="book-card" onClick={() => go({ name: "detail", bookId: b.id })}>
                  <div className="book-cover-frame">
                    {b.tag && <div className={`book-tag ${b.tag.cls}`}>{b.tag.label}</div>}
                    <BookCover book={b} name={b.placeholderName} model={MODELS[modelIdx]} />
                  </div>
                  <div className="book-meta">
                    <div className="title">
                      {b.namePrefix && (
                        <span
                          style={{
                            color: "var(--ink-soft)",
                            fontSize: 14,
                            letterSpacing: "0.02em",
                            display: "block",
                          }}
                        >
                          {b.placeholderName + " " + b.namePrefix}
                        </span>
                      )}
                      <span className="it">{b.titleSecond}</span>
                    </div>
                    <div className="price">${b.price}.00</div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="wrap">
          <div className="section-head">
            <div>
              <span className="eyebrow">— How it works</span>
              <h2>
                Three small steps, <span className="it">one giant grin.</span>
              </h2>
            </div>
          </div>
          <div className="how-grid">
            <div className="how-step">
              <div className="n">STEP 1 / PICK</div>
              <h3>Choose the story.</h3>
              <p>
                Browse our launch collection — four picture books built around the festivals, friendships and feelings
                that make childhood big.
              </p>
            </div>
            <div className="how-step">
              <div className="n">STEP 2 / MAKE</div>
              <h3>Make it theirs.</h3>
              <p>
                Add your child's name, pick from twelve character models and write a dedication only you could write.
                Takes about three minutes.
              </p>
            </div>
            <div className="how-step">
              <div className="n">STEP 3 / SHIP</div>
              <h3>We print &amp; post.</h3>
              <p>A one-of-a-kind book arrives at your door, ready to make your next story time magical.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="promise">
        <div className="wrap">
          <h2>
            Every child should be able to open a book and see <span className="it">themselves</span> looking back.
          </h2>
          <p>
            My dream is to create books that allow children of all backgrounds to see people who look like them
            reflected in print. I want them to see their culture, family and friends in these stories and for them to
            feel that their story, too, is worthy of celebration.
          </p>
          <div className="sig">Laura, founder</div>
        </div>
      </section>
    </main>
  );
}
